import { AccountsThemeHelper } from '@accounts/domain';
import { AccredibleLanguageSelectorComponent } from '@accredible-frontend-v2/components/language-selector';
import { getAvailableLanguages } from '@accredible-frontend-v2/services/language';
import { accredibleCustomThemesMetadata } from '@accredible-frontend-v2/utils/themes';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'acs-mini-footer',
  standalone: true,
  templateUrl: './mini-footer.component.html',
  styleUrls: [`./mini-footer.component.scss`],
  imports: [AccredibleLanguageSelectorComponent, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniFooterComponent {
  showBackToSignIn = input(false);

  themeName = AccountsThemeHelper.getTheme();
  languages = getAvailableLanguages(accredibleCustomThemesMetadata[this.themeName].languages);
}
